import React from 'react';
import { Grid } from 'semantic-ui-react';
import './styles.less';
import { Field } from 'redux-form';
import PropTypes from 'prop-types';
import { CustomRequiredComponent } from '../../../../../semantic-ui/components/custom-required';
import { FormInputField } from '../../../../../semantic-ui/components/form-input-field';
import { FormSelectField } from '../../../../../semantic-ui/components/form-select-field';
import { normalizeNumber } from '../../../../../utils/normalizeNumber';
import LengthIcon from '../../../../../components/icons/length-icon.svg';
import WidthIcon from '../../../../../components/icons/width-icon.svg';
import HeightIcon from '../../../../../components/icons/height-icon.svg';
import { KgIcon, LiterIcon, PieceIcon, SizeTextIcon } from '../../../../../components/text-icon';
import { normalizeInteger } from '../../../../../utils/normalizeInteger';
import { CustomLoader } from '../../../../../components/custom-loader';
import { ErrorComponent } from '../../../../../components/error-component';

export const IcepackFormView = ({ partnersOptions, isPartnersLoading, isLoading }) => {
	if (isLoading) {
		return <CustomLoader />;
	}

	return (
		<Grid className="icepack-form">
			<Grid.Row className="icepack-form__row">
				<Grid.Column width={6} className="icepack-form__column">
					Название
					<CustomRequiredComponent />
				</Grid.Column>
				<Grid.Column width={8} className="icepack-form__column">
					<Field
						name="name"
						type="text"
						component={FormInputField}
						autoComplete="off"
						placeholder="Укажите название"
					/>
				</Grid.Column>
			</Grid.Row>
			<Grid.Row className="icepack-form__row">
				<Grid.Column width={6} className="icepack-form__column">
					Производитель
					<CustomRequiredComponent />
				</Grid.Column>
				<Grid.Column width={8} className="icepack-form__column">
					<Field
						name="partner_id"
						type="text"
						component={FormSelectField}
						autoComplete="off"
						options={partnersOptions}
						search
						loading={isPartnersLoading}
						disabled={isPartnersLoading}
						noResultsMessage="Компании не найдены"
						placeholder="Выберите производителя"
						isWithoutSelectOnBlur
					/>
				</Grid.Column>
			</Grid.Row>
			<Grid.Row className="icepack-form__row">
				<Grid.Column width={6} className="icepack-form__column">
					Внешние геометрические размеры
					<CustomRequiredComponent />
				</Grid.Column>
				<Grid.Column width={8} className="icepack-form__column">
					<Grid columns={3} className="icepack-form__wrapper">
						<Grid.Row className="icepack-form__row icepack-form__row-cargo">
							<Grid.Column className="icepack-form__column-cargo" width={5}>
								<img src={LengthIcon} alt="length-icon" />
								<div className="icepack-form__field">
									<Field
										name="length"
										type="text"
										normalize={normalizeNumber}
										component={FormInputField}
										autoComplete="off"
										icon={SizeTextIcon}
										placeholder="Дл."
										isWithoutErrorText
									/>
								</div>
							</Grid.Column>
							<Grid.Column className="icepack-form__column-cargo" width={5}>
								<img src={WidthIcon} alt="width-icon" />
								<div className="icepack-form__field">
									<Field
										name="width"
										type="text"
										normalize={normalizeNumber}
										component={FormInputField}
										autoComplete="off"
										icon={SizeTextIcon}
										placeholder="Шир."
										isWithoutErrorText
									/>
								</div>
							</Grid.Column>
							<Grid.Column className="icepack-form__column-cargo" width={5}>
								<img src={HeightIcon} alt="height-icon" />
								<div className="icepack-form__field">
									<Field
										name="height"
										type="text"
										normalize={normalizeNumber}
										component={FormInputField}
										autoComplete="off"
										icon={SizeTextIcon}
										placeholder="Выс."
										isWithoutErrorText
									/>
								</div>
							</Grid.Column>
						</Grid.Row>
						<Grid.Row className="icepack-form__row icepack-form__row-cargo icepack-form__row-error">
							<Grid.Column className="icepack-form__column-cargo-error" width={16}>
								<Field name="length" component={ErrorComponent} />
							</Grid.Column>
							<Grid.Column className="icepack-form__column-cargo-error" width={16}>
								<Field name="width" component={ErrorComponent} />
							</Grid.Column>
							<Grid.Column className="icepack-form__column-cargo-error" width={16}>
								<Field name="height" component={ErrorComponent} />
							</Grid.Column>
						</Grid.Row>
					</Grid>
				</Grid.Column>
			</Grid.Row>
			<Grid.Row className="icepack-form__row">
				<Grid.Column width={6} className="icepack-form__column">
					Масса пустого
					<CustomRequiredComponent />
				</Grid.Column>
				<Grid.Column width={8} className="icepack-form__column">
					<Field
						name="weight"
						type="text"
						normalize={normalizeNumber}
						component={FormInputField}
						autoComplete="off"
						placeholder="Укажите массу пустого"
						icon={KgIcon}
					/>
				</Grid.Column>
			</Grid.Row>
			<Grid.Row className="icepack-form__row">
				<Grid.Column width={6} className="icepack-form__column">
					Объем
					<CustomRequiredComponent />
				</Grid.Column>
				<Grid.Column width={8} className="icepack-form__column">
					<Field
						name="volume"
						type="text"
						normalize={normalizeNumber}
						component={FormInputField}
						autoComplete="off"
						placeholder="Укажите объем"
						icon={LiterIcon}
					/>
				</Grid.Column>
			</Grid.Row>
			<Grid.Row className="icepack-form__row">
				<Grid.Column width={6} className="icepack-form__column">
					Кол-во в групповой упаковке
					<CustomRequiredComponent />
				</Grid.Column>
				<Grid.Column width={8} className="icepack-form__column">
					<Field
						name="package_quantity"
						type="text"
						normalize={normalizeInteger}
						component={FormInputField}
						autoComplete="off"
						placeholder="Укажите кол-во в групповой упаковке"
						icon={PieceIcon}
					/>
				</Grid.Column>
			</Grid.Row>
			<Grid.Row className="icepack-form__row">
				<Grid.Column width={6} className="icepack-form__column">
					Кол-во на паллете
				</Grid.Column>
				<Grid.Column width={8} className="icepack-form__column">
					<Field
						name="pallet_quantity"
						type="text"
						normalize={normalizeInteger}
						component={FormInputField}
						autoComplete="off"
						placeholder="Укажите кол-во на паллете"
						icon={PieceIcon}
					/>
				</Grid.Column>
			</Grid.Row>
		</Grid>
	);
};

IcepackFormView.propTypes = {
	partnersOptions: PropTypes.arrayOf(
		PropTypes.shape({
			key: PropTypes.number.isRequired,
			value: PropTypes.number.isRequired,
			text: PropTypes.string,
		}),
	).isRequired,
	isPartnersLoading: PropTypes.bool.isRequired,
	isLoading: PropTypes.bool.isRequired,
};
